function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 41,
  r: 7,
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 41,
  r: 7,
  fill: "#EDE3AA"
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 64.5,
  cy: 41,
  r: 7,
  fill: "white"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5 58.3092C5 54.7419 7.89183 51.8501 11.4591 51.8501H19.5409C23.1082 51.8501 26 54.7419 26 58.3092V58.3092C26 60.3476 24.3475 62.0001 22.3091 62.0001H8.69091C6.65248 62.0001 5 60.3476 5 58.3092V58.3092Z",
  fill: "white"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M29.5 58.3092C29.5 54.7419 32.3918 51.8501 35.9591 51.8501H44.0409C47.6082 51.8501 50.5 54.7419 50.5 58.3092V58.3092C50.5 60.3476 48.8475 62.0001 46.8091 62.0001H33.1909C31.1525 62.0001 29.5 60.3476 29.5 58.3092V58.3092Z",
  fill: "#EDE3AA"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M54 58.3092C54 54.7419 56.8918 51.8501 60.4591 51.8501H68.5409C72.1082 51.8501 75 54.7419 75 58.3092V58.3092C75 60.3476 73.3475 62.0001 71.3091 62.0001H57.6909C55.6525 62.0001 54 60.3476 54 58.3092V58.3092Z",
  fill: "white"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.5 13C8.5 9.13401 11.634 6 15.5 6H64.5C68.366 6 71.5 9.13401 71.5 13V33.0478C69.5847 31.4891 67.1524 30.5413 64.5 30.5013V14.75C64.5 13.9768 63.8732 13.35 63.1 13.35H16.9C16.1268 13.35 15.5 13.9768 15.5 14.75V30.5013C15.4418 30.5004 15.3834 30.5 15.325 30.5C12.7642 30.5 10.4011 31.3462 8.5 32.7742V13Z",
  fill: "#E5E5E5"
});
function SvgMenuIconTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 69,
    viewBox: "0 0 80 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconTeams);
export default __webpack_public_path__ + "static/media/Menu-icon-teams.d6216a899e64c5a81ea1c18a6f3d8df4.svg";
export { ForwardRef as ReactComponent };